export const QUERY_KEYS = {
  EXTERNAL_USER_DETAILS: 'externalUserDetails',
  EXTERNAL_USER_ADVERTISERS: 'externalUserAdvertisers',
} as const;
